module.exports = __webpack_public_path__ + "static/thermostat-660207657d199107faef3f4edda70cb1.svg";